import axios from "axios";

const wait = (ms: number) => new Promise((r) => setTimeout(r, ms));

/** Повторять имеет смысл только то, что могло пройти «в другой раз»: сеть, таймаут, 5xx. */
function isTransient(e: unknown): boolean {
  if (!axios.isAxiosError(e)) return false;
  if (!e.response) return true; // сеть, таймаут, CORS-обрыв
  return e.response.status >= 500;
}

/**
 * До `attempts` попыток с растущей паузой. Только для идемпотентных запросов:
 * kef-compare после выката отвечает медленно, и первый заход часто упирается
 * в таймаут — второй уже проходит.
 */
export async function withRetry<T>(
  fn: () => Promise<T>,
  { attempts = 3, baseDelayMs = 2000 } = {}
): Promise<T> {
  let lastError: unknown;
  for (let i = 0; i < attempts; i += 1) {
    try {
      return await fn();
    } catch (e) {
      lastError = e;
      if (!isTransient(e) || i === attempts - 1) throw e;
      await wait(baseDelayMs * 2 ** i);
    }
  }
  throw lastError;
}
